import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const SettingsBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/settings/personal-settings/your-profile')
  }, [])
return (
  <>
  </>
)
}